import { graphql } from "gatsby"

import { Head as BaseHead } from "@components/Head/Head"
import RichText from "@components/rich-text/renderer"
import Accordion from "@components/accordion/accordion"
import { MikanSpan } from "@components/Mikan"

const renderVideoIframe = (post) => {
  if (post.url.url.includes("youtube")) {
    return (
      <iframe
        src={post.url.url}
        title={post.title}
        className="embed-responsive-item"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; fullscreen; gyroscope; picture-in-picture; web-share"
        allowFullScreen
      />
    )
  }

  return (
    <iframe
      title={post.title}
      id="vimeo_player"
      src={post.url.url}
      className="embed-responsive-item"
      webkitallowfullscreen=""
      mozallowfullscreen=""
      allowFullScreen=""
      data-ready="true"
      data-vimeo-tracked="true"
    />
  )
}

const VideoPage = ({ data }) => {
  const { video: post } = data

  return (
    <>
      <div className="page__content">
        <section className="section section--page-section">
          <div className="row padding-vertical">
            <div className="column">
              <h1>
                <MikanSpan text={post.title} />
              </h1>
              {post.description && <MikanSpan>{post.description.childMarkdownRemark.html}</MikanSpan>}
              <div className="embed-responsive embed-responsive-16by9">{renderVideoIframe(post)}</div>
              <br />
              {post.transcript && (
                <Accordion title={post.title}>
                  <RichText body={post.transcript} mikan={post.mikan} />
                </Accordion>
              )}
            </div>
          </div>
        </section>
      </div>
    </>
  )
}

export default VideoPage

export const query = graphql`
  query ($contentful_id: String!) {
    video: contentfulVideo(contentful_id: { eq: $contentful_id }) {
      contentful_id
      title
      description {
        childMarkdownRemark {
          html
        }
      }
      metaTitle
      metaDescription
      transcript {
        raw
      }
      url {
        url
      }
    }
    title: contentfulMicrocopy(contentful_id: { eq: "6VTuxwvZmKz88wZRBDHJak" }) {
      text
    }
  }
`

export const Head = (props) => {
  const { data } = props
  data.page = {}
  data.page.socialTitle = data.video.metaTitle || data.video.title
  data.page.socialDescription = data.video.metaDescription

  return <BaseHead {...props} />
}
